// extracted by mini-css-extract-plugin
export var callCard = "_rp-0";
export var callMessageButton = "_rp-1";
export var helpIcon = "_rp-3";
export var helpIconContainer = "_rp-4";
export var verticalDivider = "_rp-2";